module.exports = __webpack_public_path__ + "static/media/dental-care.94a013f2.svg";